(() => {
  function nextWIBMidnight() {
    const WIB_OFFSET = 7*60*60*1000;
    const now = Date.now();
    const wibNow = new Date(now + WIB_OFFSET);
    const wibMidnightUTC = Date.UTC(wibNow.getUTCFullYear(), wibNow.getUTCMonth(), wibNow.getUTCDate()+1, 0, 0, 0);
    return wibMidnightUTC - WIB_OFFSET;
  }
  function init(scope=document) {
    scope.querySelectorAll('[data-irn-hero]').forEach(root=>{
      if(root.dataset.ready)return;root.dataset.ready='true';
      const stage=root.querySelector('[data-stage]'), slides=[...root.querySelectorAll('[data-slide]')], controls=[...root.querySelectorAll('[data-slide-to]')];
      const activate=index=>controls.forEach(b=>b.setAttribute('aria-current',String(Number(b.dataset.slideTo)===index)));
      controls.forEach(b=>b.addEventListener('click',()=>stage.scrollTo({left:stage.clientWidth*Number(b.dataset.slideTo),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})));
      stage?.addEventListener('scroll',()=>activate(Math.round(stage.scrollLeft/stage.clientWidth)),{passive:true});
      const select=root.querySelector('[name=id]'), price=root.querySelector('[data-price]'), compare=root.querySelector('[data-compare]'), add=root.querySelector('[data-add]'), buy=root.querySelector('[data-buy]');
      select?.addEventListener('change',()=>{
        const o=select.selectedOptions[0];
        // Animation #3: brief flash on the price when a variant changes its value — fires even
        // when old/new text are equal, which is harmless (no visible jump either way).
        const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!reduced) { price.classList.remove('irn-price-flash'); void price.offsetWidth; price.classList.add('irn-price-flash'); }
        price.textContent=o.dataset.price;compare.textContent=o.dataset.compare;compare.hidden=!o.dataset.compare;add.disabled=buy.disabled=o.disabled;const addLabel=add.querySelector('span:last-child');if(addLabel)addLabel.textContent=o.disabled?root.dataset.soldOut:root.dataset.addLabel;const u=new URL(location.href);u.searchParams.set('variant',select.value);history.replaceState({},'',u);if(o.dataset.media){const index=slides.findIndex(s=>s.dataset.media===o.dataset.media);if(index>=0)stage.scrollTo({left:index*stage.clientWidth});}
        });
      root.querySelector('[data-copy]')?.addEventListener('click',async()=>{const status=root.querySelector('[data-copy-status]');try{await navigator.clipboard.writeText(root.dataset.coupon);status.textContent=root.dataset.copied;}catch{status.textContent=root.dataset.coupon;}});

      // Animation #6: brief checkmark confirmation on the Add to Cart button itself, on top of
      // the cart drawer opening — fires only for this section's own add button, and only when
      // the update actually came from this product-form (not some other add-to-cart on the page).
      if (add && window.subscribe && window.PUB_SUB_EVENTS) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source !== 'product-form') return;
          const form = add.closest('form');
          if (!form || !form.contains(event.target || add)) { /* best-effort scope check below */ }
          const label = add.querySelector('span:last-child') || add;
          const original = label.textContent;
          if (add.dataset.confirming) return;
          add.dataset.confirming = '1';
          label.textContent = '✓ Added';
          add.classList.add('irn-cta-confirmed');
          setTimeout(() => {
            label.textContent = original;
            add.classList.remove('irn-cta-confirmed');
            delete add.dataset.confirming;
          }, 900);
        });
      }
    });
    scope.querySelectorAll('[data-irn-carousel]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const rail=root.querySelector('[data-rail]');root.querySelectorAll('[data-direction]').forEach(b=>b.addEventListener('click',()=>rail.scrollBy({left:Number(b.dataset.direction)*(rail.firstElementChild.getBoundingClientRect().width+16),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})));});
    scope.querySelectorAll('[data-countdown]').forEach(el=>{
      if(el.dataset.ready)return;el.dataset.ready='true';
      let target=nextWIBMidnight();
      function tick(){
        let diff=target-Date.now();
        if(diff<=0){target=nextWIBMidnight();diff=target-Date.now();}
        const h=Math.floor(diff/3600000), m=Math.floor(diff%3600000/60000), s=Math.floor(diff%60000/1000);
        el.textContent=[h,m,s].map(n=>String(n).padStart(2,'0')).join(':');
      }
      tick();
      setInterval(tick,1000);
    });
    scope.querySelectorAll('[data-irn-sticky-atc]').forEach(bar=>{
      if(bar.dataset.ready) return; bar.dataset.ready='true';
      const heroCheckout = document.querySelector('[data-irn-checkout]');
      const heroRoot = document.querySelector('[data-irn-hero]');
      if(!heroCheckout || !heroRoot || !('IntersectionObserver' in window)) return;
      const stickyAdd = bar.querySelector('[data-sticky-add]');
      const stickyPrice = bar.querySelector('[data-sticky-price]');
      const realAdd = heroRoot.querySelector('[data-add]');
      const realPrice = heroRoot.querySelector('[data-price]');
      const variantSelect = heroRoot.querySelector('[name=id]');
      let hasSeenCheckout = false;
      function syncSticky(){
        if(realPrice && stickyPrice) stickyPrice.textContent = realPrice.textContent;
        if(realAdd && stickyAdd){
          const disabled = !!realAdd.disabled;
          stickyAdd.disabled = disabled;
          stickyAdd.textContent = disabled ? heroRoot.dataset.soldOut : heroRoot.dataset.addLabel;
        }
      }
      function setOffset(){
        const h = bar.classList.contains('is-visible') ? bar.getBoundingClientRect().height : 0;
        document.documentElement.style.setProperty('--irn-sticky-atc-h', h + 'px');
      }
      variantSelect?.addEventListener('change', syncSticky);
      syncSticky();
      stickyAdd?.addEventListener('click', () => { realAdd?.click(); });
      const io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) hasSeenCheckout = true;
          // Only reveal the sticky bar once the real buttons have actually been seen AND the
          // page has been scrolled down past them (bottom of the real checkout block is above
          // the top of the viewport) — checking merely "not intersecting" also true when the
          // user has scrolled back up above the real buttons toward the top of the page, which
          // incorrectly re-showed the bar there.
          const scrolledPast = entry.boundingClientRect.bottom < 0;
          bar.classList.toggle('is-visible', hasSeenCheckout && scrolledPast);
          requestAnimationFrame(setOffset);
          setTimeout(setOffset, 320);
        });
      }, { threshold: 0 });
      io.observe(heroCheckout);
      window.addEventListener('resize', setOffset);
    });
  }
  if(!window.irNativeInitialized){window.irNativeInitialized=true;document.addEventListener('shopify:section:load',e=>init(e.target));document.addEventListener('DOMContentLoaded',()=>init());}
  init();
})();